import cn from 'classnames';
import { Icon, IconColor, IconSize } from '../Icon';

interface CloseButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  iconSize?: IconSize;
  iconColor?: IconColor;
}

export const CloseButton: React.FC<CloseButtonProps> = ({
  iconSize = 16,
  iconColor = IconColor.EGGPLANT,
  className,
  type = 'button',
  ...props
}) => (
  <button
    {...props}
    type={type}
    className={cn(
      'border-none bg-transparent outline-none transition-transform duration-150 hover:scale-125 active:scale-100',
      className
    )}>
    <Icon name='close' size={iconSize} color={iconColor} />
  </button>
);
